import http from '@/utils/httpRequestHelper';

/**
 * Submit audio data for cloning.
 * @param {Object} data - The data to submit for audio cloning.
 * @returns {Promise} - Promise resolving to the server response.
 */
export const submitCloneAudio = (data) => http.post('/ai/audio/clone', data);
